import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {ParamListResponse, PayeeW4Info} from "@app/shared/classes/payroll-payee";
import {HttpClient} from "@angular/common/http";
import {W4Params} from "@app/shared/tax-information/tax-information";

@Injectable()
export class PayrollService {

  constructor(private http: HttpClient) { }

  get2020TaxFields() {
    let taxFields2020ToSkip: Set<W4Params> = new Set<W4Params>();
    taxFields2020ToSkip.add(W4Params.TwoJobs);
    taxFields2020ToSkip.add(W4Params.DependentsAmt);
    taxFields2020ToSkip.add(W4Params.OtherIncome);
    taxFields2020ToSkip.add(W4Params.Deductions);
    return taxFields2020ToSkip;
  }

  getNon2020TaxFieldsToSkip() {
    let non2020TaxFieldsToSkip: Set<W4Params> = new Set<W4Params>();
    non2020TaxFieldsToSkip.add(W4Params.TotalAllowances);
    return non2020TaxFieldsToSkip;
  }


  getW4ParamList(payeeId: number): Observable<ParamListResponse> {
    const url = `/payroll/payees/w4-params/${payeeId}`;
    return this.http.get<ParamListResponse>(url);
  }

  saveW4Param(payeeId: number, data: ParamListResponse): Observable<PayeeW4Info> {
    const url = `/payroll/payees/w4-params/${payeeId}`;
    return this.http.post<PayeeW4Info>(url, data);
  }
}
